import './styles.scss';
import React, {useCallback, useEffect, useState} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";
import {RecordsContext} from "../../../types/document";

/* Bootstrap */
import {Card, Col, Container, Row} from "react-bootstrap";

/* Components */
import MediaPreview from "../../cards/media-preview";
import {IViewerState} from "../../../types/redux/viewer";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";
import SEARCH_META_DATA from "../../../assets/data/search.meta.json";

interface IProps  {
  record: any;
  index: number;
  page: number;
  resultsPerPage: number;
}

const ViewerCard = (props: IProps):JSX.Element => {
  const {
    record,
    index,
    page,
    resultsPerPage
  } = props;

  const viewerState: IViewerState = useSelector<RootState, IViewerState>(state => state.viewer);
  const resultNumber: number = (page - 1) * resultsPerPage + index + 1;
  const [fields, setFields] = useState([]);
  const [batesNumber, setBatesNumber] = useState(null);

  const getTitle = useCallback((): JSX.Element => {
    const title: string = (record.highlighting && record.highlighting.ti) ? record.highlighting.ti : record.ti;
    return (
      <h6 className={"text-small ellipse mb-0"}>
        <b>
          <span>{resultNumber}. </span>
          {title ? title : Constants.NO_TITLE}
        </b>
      </h6>
    )
  }, [record.highlighting, record.ti, resultNumber]);

  const entry = (label: string, value: string | JSX.Element | undefined): JSX.Element => {
    const cssClass: string = label.toLowerCase().replace(' ', '-');
    if (value) {
      return (
        <div key={label}>
          <div className={'d-none d-lg-block mb-2 px-1 ellipse'}>
            <b>{label}</b>: {value}
          </div>

          <Row className={'d-lg-none px-3'}>
            <Col xs="5" className={'px-1 pb-2 ellipse '}><b>{label}</b></Col>
            <Col xs="7" className={'px-1 pb-2 ellipse ' + cssClass}>{value}</Col>
          </Row>
        </div>
      )
    }
    return <></>
  }

  useEffect(()=> {
    if (!record) return;

    const _fields: any[] = [];
    const fieldToInclude: string[] = ['bn', 'au', 'dd', 'dt', 'id', 'collection', 'industry', 'desc']
    const resultFields: any[] = SEARCH_META_DATA.resultFields;

    resultFields.forEach((field: any) => {
      for (const fieldId in field) {
        if (fieldToInclude.indexOf(fieldId) !== -1) {
          const mappedValues: string[] = SEARCH_META_DATA.allFields[fieldId];
          switch (fieldId) {
            case 'id':
              let value: string = record[fieldId];
              if (((record.industry.toLowerCase() === Constants.TOBACCO) || (record.industry.toLowerCase() === Constants.DRUG)) && (record['tid'])) {
                value += " ( TID : "+ record["tid"] +" )";
              }
              _fields.push(entry('ID', value))
              break;

            case 'bn':
              if (viewerState.recordTool === Constants.BATES) {
                setBatesNumber(record[fieldId])
              }
              return ;

            case 'url':
              _fields.push(entry('URL', "https://www.industrydocuments.ucsf.edu/docs/" + record.id))
              break;

            case 'dd':
              _fields.push(entry('Date', record[fieldId]))
              break;

            case 'au':
            case 'dt':
              if (Array.isArray(record[fieldId])) {
                _fields.push(entry(mappedValues[0], record[fieldId].join('; ')))
              } else {
                _fields.push(entry(mappedValues[0], record[fieldId] ? record[fieldId] : Constants.UNKNOWN))
              }
              break;

            default:
              if (Array.isArray(record[fieldId])) {
                _fields.push(entry(mappedValues[0], record[fieldId].join('; ')))
              } else {
                _fields.push(entry(mappedValues[0], record[fieldId]))
              }
          }
        }
      }
    })
    setFields(_fields);
  }, [record, viewerState.recordTool])

  return (
    <RecordsContext.Provider value={{records:[record]}}>
      {record && <Card className={"viewer-card my-0 p-0"} id={'card-' + resultNumber}>
        <Card.Header className={'px-3 py-3'}>
          {getTitle()}
        </Card.Header>

        <Card.Body className={'px-2 py-3'}>
          <Container className={'ps-1 pe-1'}>
            {batesNumber &&
              <div className={'ps-1 mb-1 bates-number text-small ellipse'}><strong>Bates:</strong> {batesNumber}</div>}

            <Col xs="12" className={'text-small'}>
              <Row className={'mb-0'}>
                <Col xs="8" >
                  <Row className={'doc-content mb-0 position-relative'}>
                    {fields.map((elem, i) => {
                      return <div key={i}>{elem}</div>
                    })}
                  </Row>
                </Col>

                {/* Preview Image */}
                <Col xs="4" className={'pe-3 h-100 center p-0'}>
                 <MediaPreview context={Constants.VIEWER}/>
                  {(viewerState.viewed.indexOf(record.id) !== -1) &&
                    <div className={'mt-1 p-1 bg-secondary rounded text-xsmall text-white text-center'}>Viewed</div>
                  }
                </Col>
              </Row>
            </Col>

          </Container>
        </Card.Body>
    </Card>}
    </RecordsContext.Provider>
  )
}

export default ViewerCard;
